import { AxiosRequestConfig } from 'axios';
import { ResetPasswordFormRequestParams } from '../types';

export const sendResetPasswordFormData = (params: ResetPasswordFormRequestParams): AxiosRequestConfig => ({
   url: `/reset-password.json`,
   method: 'get',
   params,
});
